<template>
  <div class="OrderCancellation">
    <div class="header">
      <p class="title">“一瓶一码”钢瓶溯源系统</p>
    </div>
    <div v-if="verify_code !== ''">
      <div class="details">
        <div class="cards">
          <div class="card">
            <div class="cardLogo a"></div>
            <span class="cardTitle" @click="warn">维修服务</span>
          </div>
          <div class="card">
            <div class="cardLogo b"></div>
            <span class="cardTitle" @click="warn">预约服务</span>
          </div>
        </div>
        <div class="detailA">
          <div class="head">
            <span class="cardTitle">气瓶信息</span>
          </div>
          <div class="body">
            <ul>
              <li>品牌型号：{{ testData.model }}</li>
              <li>单位钢码：{{ testData.unitSteelCode }}</li>
              <li>标签编号：{{ testData.code }}</li>
              <li>充装单位：{{ testData.fillCompany }}</li>
              <li>经营单位：{{ testData.managementCompany }}</li>
              <li>气瓶状态：在用</li>
              <li>气瓶规格：15KG</li>
              <li>生产日期：2022-04-15</li>
              <li>最后检验日期：2022-05-15</li>
              <li>质保截至：2032-05-15</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="info">
        <div class="item">
          <div class="logo a"></div>
          <span>一瓶一码</span>
        </div>
        <div class="item">
          <div class="logo b"></div>
          <span>智能放心</span>
        </div>
        <div class="item">
          <div class="logo c"></div>
          <span>安全护航</span>
        </div>
      </div>
    </div>
    <div class="scan" v-if="iswechat">
      <div class="qrBtn" @click="openQRCode">
        <span>{{ verify_code === "" ? "扫码溯源" : "继续扫码" }}</span>
        <div class="pulse1"></div>
        <div class="pulse2"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.OrderCancellation .header {
  background-color: #21c17d;
  width: 100%;
  height: 2rem;
}
.OrderCancellation .header .title {
  color: #ffffff;
  text-align: center;
  font-size: 0.5rem;
  padding-top: 0.7rem;
}
.OrderCancellation .scan {
  width: 3rem;
  height: 3rem;
  margin: 1.8rem auto;
}
.OrderCancellation .qrBtn {
  position: relative;
  width: 3rem;
  height: 3rem;
  background-color: #00c17b;
  border-radius: 50%;
}
.OrderCancellation .qrBtn span {
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  color: #fff;
  text-align: center;
  font-size: 0.5rem;
}
.pulse1,
.pulse2 {
  position: absolute;
  width: 180px;
  height: 180px;
  left: 50%;
  top: -20px;
  margin-left: -90px;
  background: #00c17b;
  border-radius: 50%;
  opacity: 0;
  z-index: -1;
  box-shadow: 1px 1px 15px #00c17b;
}
.pulse1 {
  animation: warn1 1.5s linear;
  animation-iteration-count: infinite;
}
.pulse2 {
  animation: warn2 1.5s linear;
  animation-iteration-count: infinite;
}
@keyframes warn1 {
  0% {
    transform: scale(1);
    opacity: 0.01;
  }

  25% {
    transform: scale(1.2);
    opacity: 0.1;
  }

  50% {
    transform: scale(1.4);
    opacity: 0.07;
  }

  75% {
    transform: scale(1.6);
    opacity: 0.03;
  }

  100% {
    transform: scale(1.8);
    opacity: 0.01;
  }
}

@keyframes warn2 {
  0% {
    transform: scale(0.8);
    opacity: 0.01;
  }

  25% {
    transform: scale(0.8);
    opacity: 0.13;
  }

  50% {
    transform: scale(1);
    opacity: 0.1;
  }

  75% {
    transform: scale(1.2);
    opacity: 0.07;
  }

  100% {
    transform: scale(1.4);
    opacity: 0.01;
  }
}
.OrderCancellation .info {
  padding-top: 3rem;
  width: 80%;
  margin: 0 auto;
}
.OrderCancellation .info .item {
  width: 33%;
  display: inline-block;
  padding: 0 0.2rem;
  text-align: center;
}
.OrderCancellation .info .logo {
  width: 45px;
  height: 45px;
  margin: 0 auto 0.2rem;
}
.OrderCancellation .info .a {
  background: url("../../assets/images/a.png") no-repeat center;
  background-size: 42px 42px;
}
.OrderCancellation .info .b {
  background: url("../../assets/images/b.png") no-repeat center;
  background-size: 42px 42px;
}
.OrderCancellation .info .c {
  background: url("../../assets/images/c.png") no-repeat center;
  background-size: 42px 42px;
}
.OrderCancellation .info span {
  font-size: 0.28rem;
  color: #333;
}
.OrderCancellation .cards {
  width: 100%;
}
.OrderCancellation .cards .card {
  position: relative;
  text-align: center;
  line-height: 2rem;
  display: inline-block;
  width: 50%;
  height: 2rem;
  border: 1px solid #ddd;
  border-left: 0;
}

.OrderCancellation .card .cardLogo {
  width: 45px;
  height: 45px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto 0 auto 0.3rem;
}

.OrderCancellation .card .cardTitle {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto 0 auto 0.3rem;
  font-size: 0.35rem;
}

.OrderCancellation .card .a {
  background: url("../../assets/images/d.png") no-repeat center;
  background-size: 42px 42px;
}

.OrderCancellation .card .b {
  background: url("../../assets/images/e.png") no-repeat center;
  background-size: 25px 25px;
}

.OrderCancellation .detailA .head {
  font-size: 0.35rem;
  padding: 0.2rem 0.3rem;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}

.OrderCancellation .detailA .body {
  padding: 0 0.3rem 0.2rem;
}

ul li::before {
  content: "■";
  font-size: 0.4rem;
  padding-right: 0.15rem;
  color: #00c17b;
}

.OrderCancellation .detailA .body li {
  padding: 0.2rem 0.1rem;
  border-bottom: 1px solid #ddd;
}
</style>
<script>
import { isWeixin } from "@utils";
import { wechatEvevt } from "@libs/wechat";
const NAME = "TraceSource";

const testData = [
  {
    model: "鸿业",
    unitSteelCode: "SPV077686",
    code: "3739875843",
    fillCompany: "陕西省西安市测试液化有限公司",
    managementCompany: "企石气站"
  },
  {
    model: "联腾",
    unitSteelCode: "TZ012555",
    code: "7398758433",
    fillCompany: "河北省石家庄市测试液化有限公司",
    managementCompany: "企石气站"
  },
  {
    model: "吉利",
    unitSteelCode: "JL123344",
    code: "875845503",
    fillCompany: "四川省成都市测试液化有限公司",
    managementCompany: "企石气站"
  },
  {
    model: "摩腾",
    unitSteelCode: "FT1234455",
    code: "73075843",
    fillCompany: "北京测试液化有限公司",
    managementCompany: "企石气站"
  },
  {
    model: "利能",
    unitSteelCode: "SPV077686",
    code: "3739875843",
    fillCompany: "浙江省杭州市测试液化有限公司",
    managementCompany: "企石气站"
  }
];

export default {
  name: NAME,
  components: {},
  computed: {
    testData: function() {
      return testData[this.num];
    }
  },
  props: {},
  data: function() {
    return {
      iswechat: isWeixin(),
      verify_code: "",
      num: 0
    };
  },
  mounted: function() {},
  methods: {
    toDetail() {},
    warn() {
      this.$dialog.toast({ mes: "该功能暂未开放" });
    },
    openQRCode: function() {
      let that = this;
      wechatEvevt("scanQRCode", {
        needResult: 1,
        scanType: ["qrCode", "barCode"]
      })
        .then(res => {
          this.num = Math.round(Math.random() * 4);
          that.verify_code = res.resultStr;
          that.toDetail();
        })
        .catch(res => {
          console.log(res);
          if (res.is_ready) {
            res.wx.scanQRCode({
              needResult: 1,
              scanType: ["qrCode", "barCode"],
              success: function(res) {
                that.verify_code = res.resultStr;
                that.toDetail();
              },
              fail: function(res) {
                that.$dialog.error(res.toString());
                console.log(res);
                if (res.errMsg == "scanQRCode:permission denied") {
                  that.$dialog.error("没有权限");
                }
              }
            });
          }
        });
    }
  }
};
</script>
